import {clearFeedbacksByName} from "../../helpers/forms";

function initPhoneForm(formElement) {
	// init form

	// Init call forwarding select
	const callWhisperModeSelect = formElement.querySelector('select[name="call_whisper_mode"]');
	callWhisperModeSelect.addEventListener('change', handleWhisperModeChange);

	// Initial render
	handleWhisperModeChange()

	// Init call forwarding or voice mail labels
	const callForwardingNumberInput = formElement.querySelector('input[name="forward_call_number"]');
	callForwardingNumberInput.addEventListener('keyup', handleForwardingNumberChange)

	// Initial render
	handleForwardingNumberChange();

	// Form methods
	return {
		formElement,
		formFields: [
			'name',
			'description',
			'number',
			'forward_sms_email',
			'forward_call_number',
			'forward_call_email',
			'default_response',
			'default_negative_response',
			'call_whisper_mode',
			'call_whisper_text_to_speech',
		],
		inputs() {
			return new FormData(formElement);
		},
		clearFeedbacks() {
			return clearFeedbacksByName(formElement, this.formFields);
		},
		postUrl() {
			return formElement.dataset.url;
		},
	};

	// Component methods

	function handleWhisperModeChange() {
		const callForwardingTextToSpeechContainer = formElement.querySelector('.call-forwarding-text-to-speech-container');
		const callForwardingFileContainer = formElement.querySelector('.call-forwarding-file-container');

		// Hide all inputs types
		[
			callForwardingTextToSpeechContainer,
			callForwardingFileContainer,
		].forEach(container => container.classList.add('d-none'));

		if (callWhisperModeSelect.value === 'file') {
			callForwardingFileContainer.classList.remove('d-none');
		} else if (callWhisperModeSelect.value === 'text-to-speech') {
			callForwardingTextToSpeechContainer.classList.remove('d-none');
		}
	}

	function handleForwardingNumberChange() {
		const forwardingNumber = callForwardingNumberInput.value;
		if (forwardingNumber) {
			// Hide all labels for voice mail, display forwarded call labels
			formElement.querySelectorAll('*[data-for-voicemail-calls="true"]').forEach(element => {
				element.classList.add('d-none');
			});
			formElement.querySelectorAll('*[data-for-forwarded-calls="true"]').forEach(element => {
				element.classList.remove('d-none');
			});
		} else {
			// Hide all labels for forwarded call, display voice mail labels
			formElement.querySelectorAll('*[data-for-voicemail-calls="true"]').forEach(element => {
				element.classList.remove('d-none');
			});
			formElement.querySelectorAll('*[data-for-forwarded-calls="true"]').forEach(element => {
				element.classList.add('d-none');
			});
		}
	}
}

export {initPhoneForm}
